import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface HttpRequestLog {
  id: string;
  url: string;
  method: string;
  timestamp: number;
  requestHeaders: Record<string, string>;
  requestBody: unknown;
  responseStatus?: number;
  responseHeaders?: Record<string, string>;
  responseBody?: unknown;
  duration?: number;
}

const MAX_REQUESTS = 50;

@Injectable({
  providedIn: 'root',
})
export class NetworkActivityService {
  private requestsSubject = new BehaviorSubject<HttpRequestLog[]>([]);
  requests$ = this.requestsSubject.asObservable();

  addRequest(log: HttpRequestLog): void {
    const current = this.requestsSubject.value;
    const updated = [log, ...current].slice(0, MAX_REQUESTS);
    this.requestsSubject.next(updated);
  }

  updateRequest(id: string, updates: Partial<HttpRequestLog>): void {
    const current = this.requestsSubject.value;
    const updated = current.map((req) => (req.id === id ? { ...req, ...updates } : req));
    this.requestsSubject.next(updated);
  }

  clearRequests(): void {
    this.requestsSubject.next([]);
  }
}
